import { put, takeLatest, take, select } from 'redux-saga/effects'
import { notification } from 'antd'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { RootState } from '@app-store/store'

interface TaskAction extends Action {
    payload: {
        id: string
    }
}

const { onEditRequest, onRequest, onEditFailure } = rootActions.companies.contactCompany
const { onRequest: getPreSignedUploadURL } = rootActions.contacts.getPreSignedUploadURL
const { onRequest: fileUpload } = rootActions.contacts.fileUpload
const { setEmployeesEditorModal } = rootActions.ui.companyProfile

function* contactEditorCompanySagaTask({ payload }) {
    try {
        let response
        if (payload.avatar && payload.avatar.fileList && payload.avatar.fileList[0]) {
            yield put(getPreSignedUploadURL())
            yield take('hub/contacts/get-presigned-upload-URL/onSuccess')
            const { file } = yield select((store: RootState) => store.contacts.getPreSignedUploadURL.data)
            yield put(fileUpload(payload.avatar.fileList[0]))
            yield take('hub/contacts/file-upload/onSuccess')
            payload.data.avatar = file
        } else if (typeof payload.avatar !== 'string') {
            payload.data.avatar = null
        }
        if (payload.id) {
            response = yield axios.put(`/companies/contacts/${payload.id}`, payload.data)
        } else {
            response = yield axios.post(`/companies/contacts`, payload.data)
        }
        if (response.success) {
            yield put(onRequest({ id: payload.data.company }))
            yield put(setEmployeesEditorModal({ isOpen: false, data: {} }))
            notification.success({
                message: 'Employee changes successfully.'
            })
        }
    } catch (error) {
        yield put(onEditFailure(error))
    }
}

function* contactEditorCompanySaga(): any {
    yield takeLatest<TaskAction>(onEditRequest, contactEditorCompanySagaTask)
}

export default contactEditorCompanySaga
